import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'checkboxIsChecked',
    pure: false
})
export class PipeCheckboxIsChecked implements PipeTransform {
    transform(id: any, formGroup:FormGroup, field: any, not:any = false): any {
        let list = formGroup.controls[field].value;
        if(!list)
            return not;

        if(list instanceof Array)
            list = list.reduce(function(result, item) {
                result[item] = '';
                return result;
            }, {});
        
        return not === false? list[id] != undefined : (list[id] || not);
    }
}